import { render, staticRenderFns } from "./productsUnitsGraphics.vue?vue&type=template&id=deadccf8"
import script from "./productsUnitsGraphics.vue?vue&type=script&lang=js"
export * from "./productsUnitsGraphics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports